import { useForm, SubmitHandler } from "react-hook-form";
import { supabase } from "../supabaseClient";
import { useNavigate } from "react-router-dom";
import { Mic } from "lucide-react";

type FormInputs = {
  title: string;
  description: string;
  video_url: string;
};

export const AddPodcast = () => {
  const { register, handleSubmit, formState: { errors } } = useForm<FormInputs>();
  const navigate = useNavigate();

  const onSubmit: SubmitHandler<FormInputs> = async (data) => {
    const { error } = await supabase.from("podcasts").insert({
      title: data.title,
      description: data.description,
      video_url: data.video_url,
    });

    if (error) {
      alert("Erreur : " + error.message);
    } else {
      alert("Podcast ajouté !");
      navigate("/podcast");
    }
  };

  return (
    <section className="min-h-screen w-full p-6 mx-auto bg-gray-50 text-gray-900 dark:bg-gray-950 dark:text-gray-100">
      <div className="max-w-xl mx-auto">
        <h1 className="text-2xl font-bold mb-6 text-center text-orange-600 dark:text-orange-400 flex items-center justify-center gap-2">
          <Mic className="w-6 h-6" />
          Ajouter un Podcast
        </h1>

        <form
          onSubmit={handleSubmit(onSubmit)}
          className="space-y-4 rounded-2xl border bg-white border-gray-200 shadow-sm p-6
                     dark:bg-gray-900 dark:border-gray-800"
        >
          <div>
            <input
              {...register("title", { required: true })}
              className="w-full rounded px-3 py-2 border
                         bg-white border-gray-300 text-gray-900 placeholder-gray-400
                         focus:outline-none focus:ring-2 focus:ring-orange-400/60
                         dark:bg-gray-800 dark:border-gray-700 dark:text-gray-100 dark:placeholder-gray-400"
              placeholder="Titre du podcast"
            />
            {errors.title && (
              <p className="mt-1 text-sm text-red-600 dark:text-red-400">Titre requis</p>
            )}
          </div>

          <div>
            <textarea
              {...register("description", { required: true })}
              rows={3}
              className="w-full rounded px-3 py-2 border
                         bg-white border-gray-300 text-gray-900 placeholder-gray-400
                         focus:outline-none focus:ring-2 focus:ring-orange-400/60
                         dark:bg-gray-800 dark:border-gray-700 dark:text-gray-100 dark:placeholder-gray-400"
              placeholder="Description"
            />
            {errors.description && (
              <p className="mt-1 text-sm text-red-600 dark:text-red-400">Description requise</p>
            )}
          </div>

          <div>
            <input
              {...register("video_url", {
                required: "Lien YouTube requis",
                pattern: {
                  value: /^https:\/\/(www\.)?youtube\.com\/watch\?v=.+$/,
                  message: "Lien YouTube invalide",
                },
              })}
              className="w-full rounded px-3 py-2 border
                         bg-white border-gray-300 text-gray-900 placeholder-gray-400
                         focus:outline-none focus:ring-2 focus:ring-orange-400/60
                         dark:bg-gray-800 dark:border-gray-700 dark:text-gray-100 dark:placeholder-gray-400"
              placeholder="https://www.youtube.com/watch?v=..."
            />
            {errors.video_url && (
              <p className="mt-1 text-sm text-red-600 dark:text-red-400">{errors.video_url.message}</p>
            )}
          </div>

          <button
            type="submit"
            className="w-full bg-[#fc7825] hover:bg-orange-600 text-white font-semibold py-2 px-4 rounded
                       focus:outline-none focus:ring-2 focus:ring-orange-400/60"
          >
            Ajouter le podcast
          </button>
        </form>
      </div>
    </section>
  );
};
